import { ONE_DAY, ONE_HOUR, ONE_MINUTE, ONE_SECOND, TEN_MINUTES } from './durations';
import { GlobalText } from '../i18n/global-text';

export function globalizeCompletedDate(completedDate: string | number | undefined): string {
  return completedDate ? GlobalText.completedDate(new Date(completedDate).toLocaleDateString()) : null;
}

export function formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  return [year, month, day].join('-');
}

const isWithinNext10Minutes = (startTime: number): boolean => {
  return startTime - Date.now() <= TEN_MINUTES;
};

export const isInPast = (timestamp: number): boolean => Math.sign(timestamp - Date.now()) === -1;

export function formatLiveWorkoutStartTime(locales: string | string[], timestamp: number): string {
  const startTime = new Date(timestamp);
  let options: Intl.DateTimeFormatOptions;

  if (startTime.toDateString() === new Date().toDateString()) {
    options = {
      hour: 'numeric',
      minute: '2-digit',
    };
  } else {
    options = {
      weekday: 'long',
      hour: 'numeric',
      minute: '2-digit',
    };
  }

  let label = GlobalText.liveDate(startTime.toLocaleString(locales, options));

  if (isWithinNext10Minutes(timestamp) && !isInPast(timestamp)) {
    const now = Date.now();
    const msUntilWorkoutStarts = timestamp - now;
    const minutesUntilWorkoutStarts = Math.floor(((msUntilWorkoutStarts % ONE_DAY) % ONE_HOUR) / ONE_MINUTE);
    const secondsUntilWorkoutStarts = Math.floor(
      (((msUntilWorkoutStarts % ONE_DAY) % ONE_HOUR) % ONE_MINUTE) / ONE_SECOND
    );
    const paddedSeconds = `${secondsUntilWorkoutStarts}`.padStart(2, '0');
    label = GlobalText.startingInTime(`${minutesUntilWorkoutStarts}:${paddedSeconds}`);
  }

  if (isInPast(timestamp)) {
    label = GlobalText.liveNow;
  }

  return label;
}
